import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer: React.FC = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" align="center">
          &copy; {currentYear} WG Tech IT. Todos os direitos reservados.
        </Typography>
        <Typography variant="body2" align="center">
          <Link color="inherit" href="https://www.wgtechit.com/imigra-pulse-canada" target="_blank" rel="noopener">
            Visite nosso site
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
